import querystring from 'querystring'

import React from 'react'
import { compose } from 'redux'

import ExperimentsProvider from '@cred/react-experiments/provider'

import vtConfig from 'experiments/vtConfig'
import withReduxProvider from 'components/hocs/withReduxProvider'
import withApolloProvider from 'components/hocs/withApolloProvider'

const withExperimentProvider = (WrappedComponent) => (props) =>
  (
    <ExperimentsProvider
      config={vtConfig}
      url={window.location.href}
      queryParams={querystring.decode(window.location.search)}
      userAgent={window.navigator.userAgent}
      allowSetCookiesAsThirdparty
    >
      <WrappedComponent {...props} />
    </ExperimentsProvider>
  )

export default compose(withApolloProvider, withReduxProvider, withExperimentProvider)
